export default __webpack_public_path__ + "static/media/grafema_SET_11.b1295b83.jpg";